import { Expose } from 'class-transformer';

@Expose()
export class CustomerStatus {
  IsAquacomCustomer: boolean;

  IsCustomerActive: boolean;
  CustomerFound: boolean;
}
